import axios from "axios"
import { API_URL } from "./constant"

export async function login(app_code) {
    try {
        const response = await fetch(`${API_URL}/login/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ app_code })
        });

        if (!response.ok) {
            // Handle HTTP errors (e.g., 404, 500)
            const errorData = await response.json();
            throw new Error(JSON.stringify(errorData));
        }

        const data = await response.json();
        // console.log("Login data:", data);
        return data;
    } catch (error) {
        console.error("Fetch register API error:", error);

        // Ensure error is an object, not a string
        if (error.status) {
            throw error;
        } else {
            throw { status: 500, data: { message: "Something went wrong!" } };
        }
    }
}

export async function register(obj) {
    try {
        const response = await fetch(`${API_URL}/register/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                first_name: obj.firstName,
                last_name: obj.lastName,
                company_name: obj.companyName,
                email_id: obj.email,
                phone_number: obj.phone,
            }),
        });

        const data = await response.json();

        if (!response.ok) {
            throw { status: response.status, data };
        }

        return data;
    } catch (error) {
        console.error("Fetch register API error:", error);

        // Ensure error is an object, not a string
        if (error.status) {
            throw error; // Re-throw error so `useMutation` can catch it
        } else {
            throw { status: 500, data: { message: "Something went wrong!" } };
        }
    }
}
